import { openCloseLoginModal } from './loginModal/LoginModalSlice';
import { refreshToken } from './thisUser/thisUserSlice';

const tokenMiddleware =
  (store: any) => (next: (action: unknown) => unknown) => (action: unknown) => {
    if (
      // @ts-expect-error it's ok
      action.type === 'user/renewToken' ||
      // @ts-expect-error it's ok
      action.type === 'thisUser/logoutUser'
    ) {
      return next(action);
    }
    const state = store.getState();
    const expireDate = state.thisUser.expireDate;
    const now = Date.now();
    const refreshThreshold = now + 12 * 60 * 60 * 1000; // 12 hours from now

    if (expireDate < now) {
      store.dispatch(openCloseLoginModal());
      // await store.dispatch(logOutUser());
    } else if (refreshThreshold > expireDate) {
      store.dispatch(refreshToken({}));
    }
    return next(action);
  };

export default tokenMiddleware;
